import "jquery-waypoints/waypoints";

jQuery(document).ready(function () {
    // デバイス判別してbodyにclass追加
    var ua = navigator.userAgent;
    const isIPad = /iPad|Macintosh/i.test(navigator.userAgent) && "ontouchend" in document; //ipadOS用
    if (ua.indexOf("iPhone") > 0 || (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)) {
        $("body").addClass("device-sp");
    } else if (ua.indexOf("iPad") > 0 || ua.indexOf("Android") > 0 || isIPad) {
        $("body").addClass("device-tab");
    } else {
        $("body").addClass("device-pc");
    }

    // スマホ時、電話番号設定
    if ((ua.indexOf("iPhone") > 0 && ua.indexOf("iPod") == -1) || (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0 && ua.indexOf("SC-01C") == -1 && ua.indexOf("A1_07") == -1)) {
        $(".tel_link").each(function () {
            var str = $(this).text();
            $(this).html(
                $("<a>")
                    .attr("href", "tel:" + str.replace(/-/g, ""))
                    .append(str + "</a>")
            );
        });
    }

    // #で始まるアンカーをクリックした場合に処理
    $('a[href*="#"]:not(.disable)').click(function () {
        // 移動先取得
        var target = $(this.hash);

        if (!target.length) return;

        if (location.pathname.replace(/^\//, "") !== this.pathname.replace(/^\//, "") || location.hostname !== this.hostname) {
            return;
        } else {
            // スクロール速度
            var speed = 500;
            // 移動アニメーション
            var targetPos = target.offset().top;
            $("html, body").animate({ scrollTop: targetPos }, speed, "swing");
            return false;
        }
    });

    //リンク無効
    $("a.disable").click(function () {
        return false;
    });

    //desvg用
    if ($(".desvg").length > 0) {
        deSVG(".desvg", true);
    }

    // 高さ調整
    $(".m_height").matchHeight();
    $(".parts_recruit_link_item .text").matchHeight();

    //モーダル設定
    $(".magnific-popup-modal").magnificPopup({
        type: "inline",
        preloader: false,
        showCloseBtn: false,
    });

    //アニメーション設定
    $(".animation_box").waypoint(
        function (direction) {
            var activePoint = $(this.element);
            if (direction === "down") {
                //scroll down
                activePoint.addClass("active");
            } else {
                //scroll up
                activePoint.removeClass("active");
            }
        },
        { offset: "70%" }
    );
});
